import React from "react";
import { NavLink } from "react-router-dom";
import { TermsContainer } from "./style";

export const Terms = () => {
  return (
    <TermsContainer>
      <NavLink to="//tankhahgardan.com/terms/" target="_blank">
        مطالعه قوانین
      </NavLink>
    </TermsContainer>
  );
};
